export const CHAIN_ICON_META = {
  ethereum: { className: 'eth-chain-icon', label: 'ETH', name: 'Ethereum' },
  polygon: { className: 'pol-chain-icon', label: 'POL', name: 'Polygon' },
  solana: { className: 'sol-chain-icon', label: 'SOL', name: 'Solana' },
  tron: { className: 'tron-chain-icon', label: 'TRX', name: 'Tron' },
  prc: { className: 'prc-chain-icon', label: 'PRC', name: 'PRC Mainnet', image: '/images/chains/prc.png' },
  evm: { className: 'evm-chain-icon', label: 'EVM', name: 'Ethereum / Polygon' },
  block: { className: 'block-chain-icon', label: '⛓', name: 'Multi-chain' },
};

const STACKED_CHAINS = {
  evm: ['ethereum', 'polygon'],
};

function ChainIconSingle({ chain, size = 'md', className = '' }) {
  const meta = CHAIN_ICON_META[chain] || CHAIN_ICON_META.evm;

  if (meta.image) {
    return (
      <img
        src={meta.image}
        alt={meta.name}
        className={`chain-icon chain-icon--${size} chain-icon--img ${className}`.trim()}
        title={meta.name}
      />
    );
  }

  return (
    <span
      className={`chain-icon chain-icon--${size} eth-tx-chain-icon ${meta.className} ${className}`.trim()}
      title={meta.name}
      aria-hidden
    >
      {meta.label}
    </span>
  );
}

function ChainIcon({ chain, size = 'md', className = '' }) {
  const stacked = STACKED_CHAINS[chain];

  if (stacked) {
    return (
      <span
        className={`chain-icon-stack chain-icon-stack--${size} ${className}`.trim()}
        title={CHAIN_ICON_META[chain]?.name}
        aria-label={CHAIN_ICON_META[chain]?.name}
      >
        {stacked.map((item) => (
          <ChainIconSingle key={item} chain={item} size={size} className="chain-icon-stack__item" />
        ))}
      </span>
    );
  }

  const meta = CHAIN_ICON_META[chain] || CHAIN_ICON_META.evm;

  if (meta.image) {
    return (
      <img
        src={meta.image}
        alt={meta.name}
        className={`chain-icon chain-icon--${size} chain-icon--img ${className}`.trim()}
        title={meta.name}
      />
    );
  }

  return (
    <span
      className={`chain-icon chain-icon--${size} eth-tx-chain-icon ${meta.className} ${className}`.trim()}
      title={meta.name}
      aria-label={meta.name}
    >
      {meta.label}
    </span>
  );
}

export default ChainIcon;
